import ReactModal from "react-modal";
import styled, { createGlobalStyle, css } from "styled-components";
import { rgba } from "polished";

import {
  breakpoint,
  ContentWidth,
  zIndex,
  colors,
  boxShadow,
  space,
} from "shared/styles/constants";
import { CloseButton } from "../Button";
import { motion } from "framer-motion";

export interface ModalStyleProps {
  isContained?: boolean;
  isFullscreen?: boolean;
  width?: ContentWidth | string;
}

export const StyledModalOverlay = createGlobalStyle`
  .ReactModal__Overlay {
    background-color: ${rgba(colors.extraBlack, 0.9)} !important;

    width: 100vw;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: ${zIndex.modal};

    overflow-y: auto;

    pointer-events: all;

    ${breakpoint("s", "down")} {
      align-items: flex-start;
    }
  }

  // prevent background page from scrolling when the modal is open
  .ReactModal__Html--open,
  .ReactModal__Body--open {
    overflow: hidden;
  }
`;

export const StyledModal = styled(ReactModal)<ModalStyleProps>`
  position: relative;

  width: fit-content;
  max-width: 95vw;
  margin: auto;

  box-shadow: ${boxShadow.xl};

  ${({ isContained, isFullscreen, width }) =>
    isContained &&
    !isFullscreen &&
    css`
      width: ${width || ContentWidth.default};
      max-height: 100%;
      margin-top: 15vh;
      margin-bottom: 15vh;

      ${breakpoint("s", "down")} {
        margin-top: 0;
      }
    `};

  ${({ isFullscreen }) =>
    isFullscreen &&
    css`
      width: 95vw;
      height: 95vh;
    `};

  &:focus-within {
    outline: none;
  }
`;

interface StyledCloseButtonProps {
  hasTitle?: boolean;
}

export const StyledCloseButton = styled(CloseButton)<StyledCloseButtonProps>`
  position: absolute;
  top: ${({ hasTitle }) => (hasTitle ? space.xxs : space.xs)};
  right: ${({ hasTitle }) => (hasTitle ? space.xxs : space.xs)};

  z-index: ${zIndex.above};
`;

export interface StyledModalContentProps {
  isFullscreen?: boolean;
}

export const StyledModalContent = styled(motion.div)<StyledModalContentProps>`
  ${({ isFullscreen }) =>
    isFullscreen &&
    css`
      display: flex;
      align-items: stretch;

      height: 100%;
    `};
`;
